import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { useEffect, useMemo, useState } from 'react'
import { toast } from '@sales-center/components'
import { getUser } from '../api'
import { IGetUser } from '@user/store/users/typings'
import { useSelector } from 'react-redux'
import { selectAllUsers } from '@user/store/users'

export const useGetUser = (
  getResourceCount?: boolean,
  checkEmailUnique?: boolean,
) => {
  const dispatch = useAppDispatch()

  const [userId, setUserId] = useState<string>()
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const allUsers = useSelector(selectAllUsers)

  const user = useMemo(
    () => allUsers.find((user) => user.id === userId),
    [allUsers, userId],
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (userId) {
        setStatus('pending')
        try {
          const input: IGetUser = {
            id: userId,
            getResourceCount: getResourceCount,
            checkEmailUnique,
          }
          const result: any = await dispatch(getUser(input))

          if (mounted) {
            if (getUser.fulfilled.match(result)) {
              setStatus('success')
            } else {
              setStatus('fail')
              toast.error(result)
            }
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
          }
        } finally {
          setStatus('idle')
        }
      } else {
        setStatus('idle')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, userId, getResourceCount])

  return { status, user, setUserId }
}
